export const splashTransition = {duration: 0.6, ease: [0.43, 0.13, 0.23, 0.96]}

export const homeTransition = {duration: 2, ease: [0.6, 0.01, 0.05, 0.9]}


